module.exports = __webpack_public_path__ + "static/media/Asset 4.7d8c61a2.svg";